import { ContainerModule } from 'inversify';
import ProductsService from '../features/products/data/service/ProductsService';
import ProductsRepository from '../features/products/data/ProductsRepository';
import { ProductsServiceInterface } from '../features/products/data/service/ProductsService.types';
import { ProductsRepositoryInterface } from '../features/products/domain/ProductsRepositoryInterface';
import GetAllProductsByStoreUseCase from 'src/features/products/domain/useCases/GetAllProductsByStoreUseCase';
import CategoryPromotionalProductsUseCase from 'src/features/products/domain/useCases/CategoryPromotionalProductsUseCase';
import GroupedPromotionalProductsUseCase from 'src/features/products/domain/useCases/GroupedPromotionalProductsUseCase';
import ProductsOnPromotionListUseCase from 'src/features/products/domain/useCases/ProductsOnPromotionListUseCase';
import GetProductsByBrandUseCase from 'src/features/products/domain/useCases/GetProductsByBrandUseCase';

export const productsBindings = new ContainerModule((bind) => {
  bind<ProductsServiceInterface>(ProductsService).to(ProductsService);
  bind<ProductsRepositoryInterface>(ProductsRepository).to(ProductsRepository);

  // Use cases
  bind<GetAllProductsByStoreUseCase>(GetAllProductsByStoreUseCase).to(
    GetAllProductsByStoreUseCase
  );
  bind<CategoryPromotionalProductsUseCase>(
    CategoryPromotionalProductsUseCase
  ).to(CategoryPromotionalProductsUseCase);
  bind<GroupedPromotionalProductsUseCase>(GroupedPromotionalProductsUseCase).to(
    GroupedPromotionalProductsUseCase
  );
  bind<ProductsOnPromotionListUseCase>(ProductsOnPromotionListUseCase).to(
    ProductsOnPromotionListUseCase
  );
  bind<GetProductsByBrandUseCase>(GetProductsByBrandUseCase).to(
    GetProductsByBrandUseCase
  );
});
